import React from 'react';
import PropTypes from 'prop-types';

import './thirdLevelBoard.scss';
import Button, { BUTTON_TYPES, BUTTON_SIZES } from '../Button';
import closeIcon from '../../assets/icons/close-black.png';

export default function ThirdLevelBoard(props) {
  const { headingLabel, onDone, children } = props;

  return (
    <div className="third-level-board-container">
      <div className="third-level-board-heading">
        {headingLabel}
        <Button
          type={BUTTON_TYPES.ICON}
          icon={closeIcon}
          altText="close"
          onClick={onDone}
          style={{ float: 'right' }}
        />
      </div>
      <div className="third-level-board-content">{children || null}</div>
      <div className="third-level-board-button-container">
        <Button
          label="Done"
          type={BUTTON_TYPES.CTA}
          onClick={onDone}
          size={BUTTON_SIZES.SMALL}
        />
      </div>
    </div>
  );
}

ThirdLevelBoard.propTypes = {
  color: PropTypes.string,
  onChange: PropTypes.func,
  onDone: PropTypes.func
};

ThirdLevelBoard.defaultProps = {
  color: '#234556',
  onChange: () => { },
  onDone: () => { }
};
